import connectionSlice from './reducer'

export default connectionSlice.reducer
